import { SketchPicker } from 'react-color';
import reactCSS from 'reactcss';
import { setStyle } from '../utility';
const equal = require('fast-deep-equal');

const colorParse = require('color-parse');
const { Component, Fragment } = wp.element;
const { applyFilters } = wp.hooks;

class ReactColorPicker extends Component {
	constructor(props) {
		super(props);

		// @TODO this should probably be added via getDerivedStateFromProps() instead?
		// If so, test props have changed and then
		const col = colorParse(props.attribute);
		const colObj = ReactColorPicker.getStateColor(col);

		//console.log('colObj: ', colObj);
		//console.log('PROPS: ', props);

		// @TODO filter this for pro (swatches)
		const tmpState = applyFilters(
			'color-picker-initial-state',
			{
				displayColorPicker: false,
				color: colObj,
				disableAlpha: true,
				swatch: [],
				//swatch: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
			},
			this.props.attributes,
			this.props.setAttributes
		);

		this.state = tmpState;

		// set state from prop

		//colorParse
		//console.log('PROPS: ', colorParse(props.attribute), props);
	}

	componentDidMount() {
		//console.log('REACTCOLORPICKER: componentDidMount');
	}

	componentDidUpdate() {
		//console.log('REACTCOLORPICKER: componentDidUpdate');
	}

	static getDerivedStateFromProps(props, state) {
		const col = colorParse(props.attribute);
		const tmpColObj = ReactColorPicker.getStateColor(col);

		//console.log('2. getDerivedStateFromProps: ', col, tmpColObj);
		//console.log('<<<<< getDerivedStateFromProps', tmpColObj, state.color);

		// expect CSS value to be empty, or 1,2,3,4 values
		if (equal(tmpColObj, state.color)) {
			//console.log('...................EQUAL: DO NOTHING');
			return null;
		}
		//console.log('...................NOT EQUAL: UPDATING...');
		const tmpState = { ...state };
		tmpState.color = tmpColObj;
		return tmpState;
	}

	static getStateColor = (col) => {
		//console.log('COL COL COL::: ', col);
		const tmpObj = {};

		if (Array.isArray(col.values)) {
			if (typeof col.values[0] !== 'undefined') {
				tmpObj.r = col.values[0];
			} else {
				tmpObj.r = 255;
			}
			if (typeof col.values[1] !== 'undefined') {
				tmpObj.g = col.values[1];
			} else {
				tmpObj.g = 255;
			}
			if (typeof col.values[2] !== 'undefined') {
				tmpObj.b = col.values[2];
			} else {
				tmpObj.b = 255;
			}
			if (typeof col.alpha !== 'undefined') {
				tmpObj.a = col.alpha;
			} else {
				tmpObj.a = 1;
			}
		}

		return tmpObj;
	};

	handleClick = () => {
		this.setState(
			{
				displayColorPicker: !this.state.displayColorPicker,
			},
			() => {
				const { updateLabel, title } = this.props;

				updateLabel(title);
			}
		);
	};

	handleClose = () => {
		this.setState(
			{
				displayColorPicker: false,
			},
			() => {
				const { updateLabel } = this.props;

				updateLabel('');
			}
		);
	};

	handleHoverOver = () => {
		const { title, updateLabel } = this.props;
		//console.log("MY PROPS", this.props);
		updateLabel(title);
	};

	handleChange = (color) => {
		this.setState({ color: color.rgb }, () => {
			const { update } = this.props;

			// output rgb() or rgba()
			const colStr = this.state.disableAlpha
				? `rgb(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b})`
				: `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`;

			const tmpObj = {};
			tmpObj[update] = colStr;

			//console.log('UPDATING COLOR: ', update, tmpObj, colStr, color.rgb);
			setStyle(update, colStr, this.props);
		});
	};

	render() {
		const { title, colIndex } = this.props;

		//console.log('>>>>> RENDER REACTCOLORPICKER: ', `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`, this.state.color, this.props.update);

		const styles = reactCSS({
			default: {
				color: {
					width: '25px',
					height: '22px',
					borderRadius: '2px',
					background: `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`,
				},
				swatch: {
					padding: '0',
					marginRight: '6px',
					marginBottom: '4px',
					background: '#fff',
					borderRadius: '1px',
					//border: '1px #aaa solid',
					boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
					display: 'inline-block',
					cursor: 'pointer',
				},
				popover: {
					position: 'absolute',
					zIndex: '2',
					left: '0',
					top: '92px',
				},
				cover: {
					position: 'fixed',
					top: '0px',
					right: '0px',
					bottom: '0px',
					left: '0px',
				},
			},
		});

		return (
			<Fragment>
				<div
					// title={ title }
					style={styles.swatch}
					onClick={this.handleClick}
					onMouseEnter={this.handleHoverOver}
				>
					<div style={styles.color} />
				</div>
				{this.state.displayColorPicker && (
					<div style={styles.popover}>
						<div style={styles.cover} onClick={this.handleClose} />
						<SketchPicker
							presetColors={this.state.swatch}
							disableAlpha={this.state.disableAlpha}
							color={this.state.color}
							onChange={this.handleChange}
						/>
					</div>
				)}
			</Fragment>
		);
	}
}

export default ReactColorPicker;
